import { CodeSnippetControl } from "../../../typings/grid";
import JsCmFormStyles from "../CampaignMonitor/JsCmFormStyles";
import React, { useEffect } from "react";

const CodeSnippet: React.FC<CodeSnippetControl> = (control) => {
    const codeSnippet = control.codeSnippet || control.content.properties.codeSnippet;

    useEffect(() => {
        if (!codeSnippet) return;

        // Create temporary container to parse HTML
        const temp = document.createElement('div');
        temp.innerHTML = codeSnippet;

        // Find all script tags
        const scripts = temp.getElementsByTagName('script');
        const scriptsArray = Array.from(scripts);

        scriptsArray.forEach(script => script.remove());

        // Insert remaining HTML
        const container = document.getElementById('code-snippet-container');
        if (container) {
            container.innerHTML = temp.innerHTML;
        }

        // Load scripts sequentially
        const loadScripts = async () => {
            for (const script of scriptsArray) {
                const newScript = document.createElement('script');

                // Copy attributes
                Array.from(script.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                });

                // Handle both external and inline scripts
                if (script.src) {
                    newScript.src = script.src;
                } else {
                    newScript.textContent = script.textContent;
                }

                // Wait for each script to load
                await new Promise((resolve, reject) => {
                    newScript.onload = resolve;
                    newScript.onerror = reject;
                    document.body.appendChild(newScript);
                }).catch(console.error);
            }
        };

        loadScripts();

        return () => {
            const scripts = document.querySelectorAll('script[data-codesnippet]');
            scripts.forEach(script => script.remove());
        };
    }, [codeSnippet]);

    if (!codeSnippet) {
        return <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 p-4">No code inserted.</div>;
    }

    const containsFormWithClass = (className: string) => {
        return codeSnippet.indexOf(className) > 0;
    };

    return (
        <>
            {containsFormWithClass("js-cm-form") ? <JsCmFormStyles /> : null}
            <div id="code-snippet-container" className="code-snippet-container" />
        </>
    );
};

export default CodeSnippet;